// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"e2053018","982":"f5efa212"}[chunkId] + ".chunk.css";
};